import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isEnroll: localStorage.getItem("isEnroll")? true:false,
};

export const enrollSlice = createSlice({
  name: 'enroll',
  initialState,
  reducers: {
    updateEnrollCheck: (state, action) => {
      localStorage.setItem("isEnroll",action.payload)
      state.isEnroll = action.payload;
    },
    removeEnrollFlg: (state) => {
        localStorage.removeItem("isEnroll")
        state.isEnroll = false
    }
  },
});

export const { updateEnrollCheck, removeEnrollFlg } = enrollSlice.actions;
export default enrollSlice.reducer;
